import { FC } from 'react';
import { Card } from '../../ui/Card';
import { Badge } from '../../ui/Badge';

export const PlansSettingsTab: FC = () => {
  return (
    <div className="space-y-6">
      {/* 
        Módulo de Assinaturas e Planos em Andamento
        TODO: Ativar este módulo quando a integração com gateway (Stripe/Asaas) estiver conectada.
      */}
      <Card id="plans-and-billing">
        <Card.Header
          title={
            <div>
              <h3 className="text-sm font-semibold text-content-main">
                Planos e Faturamento
              </h3>
              <p className="text-xs text-content-muted">
                Gerenciamento de pacote contratado, limites operacionais e
                histórico financeiro
              </p>
            </div>
          }
          action={
            <Badge variant="neutral" className="text-micro">
              Em andamento
            </Badge>
          }
        />
        <Card.Body className="space-y-4">
          <div className="rounded-xl border border-surface-border bg-surface-subtle p-6 text-center">
            <p className="text-xs font-medium text-content-main">
              Módulo de Planos e Pagamentos em andamento
            </p>
            <p className="mt-1 text-xs text-content-muted">
              A contratação de planos e o gerenciamento de faturas serão
              disponibilizados em breve.
            </p>
          </div>

          {/* 
            TODO: Descomentar e integrar os blocos abaixo com a API de faturamento:

            1. Assinatura Atual:
            - Detalhes do plano (Plano Pro Operacional / Enterprise)
            - Limites operacionais: Grupos WhatsApp ilimitados, cadência de envio, páginas ponte
            - Botão para gerenciar/atualizar assinatura

            2. Métodos de Pagamento:
            - Cadastro de cartão corporativo, chave Pix ou boleto
            - Botão para adicionar forma de pagamento

            3. Faturas e Recibos Fiscais:
            - Tabela de histórico de faturas pagas e download de comprovantes
          */}
        </Card.Body>
      </Card>
    </div>
  );
};
